<template>
  <div class="container">
    <div class="banner-image-container">
      <el-image class="banner-image"
                :src="src"
                fit="fill">
        <div slot="placeholder"
             class="image-slot">
        </div>
      </el-image>
    </div>
    <div class="top-menu">
      <top-menu />
    </div>
    <div class="title-container">
      <h1 class="title">地理编码</h1>
      <h2 class="sub-title">
        将详细的结构化地址转换为美团经纬度坐标，且支持名胜景区、标志性建筑物名称解析
      </h2>
      <img :src="iconWeb"
           class="icon-web"
           alt="" />
      <span class="icon-desc">Web</span>
      <router-link to="/support/geo"><button class="yello-btn">开发文档</button></router-link>
    </div>
  </div>
</template>

<script>
import TopMenu from '../../TopMenu';

export default {
  created() {},
  data() {
    return {
      src: require('@/assets/img/service/geocoding/banner.png'),
      iconWeb: require('@/assets/img/icon-web.svg')
    };
  },
  methods: {
    onClick() {
      this.$router.push('/profile');
    }
  },
  components: {
    TopMenu
  }
};
</script>
<style lang="less" scoped>
.container {
  position: relative;
  width: 100%;
  height: 488px;
  .banner-image-container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    background-color: black;
    .image-slot {
      width: 1440px;
      background-color: transparent;
    }
  }
  .banner-image {
    width: 1440px;
    height: 488px;
  }
  .top-menu {
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .title-container {
    width: 1200px;
    position: absolute;
    padding-left: 60px;
    top: 124px;
    left: 50%;
    transform: translateX(-50%);
    .title {
      font-family: MeituanType-Regular;
      font-size: 42px;
      color: #fff;
      font-weight: 400;
      line-height: 59px;
    }
    .sub-title {
      margin-top: 18px;
      font-family: MeituanType-Regular;
      font-size: 18px;
      color: rgba(255, 255, 255, 0.72);
      font-weight: 200;
      line-height: 25px;
    }
    .icon-web {
      margin-top: 18px;
      width: 18px;
      height: 18px;
    }
    .icon-desc {
      margin-top: 18px;
      color: rgba(255, 255, 255, 0.72);
      font-weight: 400;
      line-height: 25px;
      font-family: MeituanType-Regular;
      font-size: 18px;
    }
    .yello-btn {
      display: block;
      margin-top: 57px;
      background: #ffd100;
      border-radius: 51px;
      width: 136px;
      height: 42px;
      font-size: 18px;
      color: rgba(0, 0, 0, 0.84);
      font-weight: 600;
      line-height: 25px;
      padding: 9px 0;
      letter-spacing: 0;
      border: none;
      cursor: pointer;
    }
  }
}
</style>
